/**
 * Плашка выделенного проекта («Выделить проект», концепт project-menu 2.1) — у строки-карточки и однострочной:
 * красный 15 % поверх обычной плашки, при наведении и у выбранной — поверх их плашек. Выделение общее для всех.
 */
export const HIGHLIGHTED = {
  idle: 'nd:bg-row-highlight nd:hover:bg-row-highlight-hover',
  selected: 'nd:bg-row-highlight-selected nd:hover:bg-row-highlight-selected',
} as const;
